import React, { Component } from "react"

import HSGModalComponent from "./../../HSGModalComponent/HSGModalComponent"
// import GoogleNewsRss from "google-news-rss";

import { DataphiGrid } from "../../../Components/GridComponent/DataphiGrid/DataphiGrid"
import Loader from "dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent"

// import { LazyLoadImage } from "react-lazy-load-image-component"

import moment from "moment";

import Select from 'react-select';

import Constants from "../../../Phi/Constants"
import Source from "../source.js"

import iconLocation from  "../../../Assets/pencil.svg"

import "./CovidStats.css"

import imageRSSDefault from "./Assets/image-rss-default.png"

class CovidStats extends Component {
    constructor(props) {
        super(props)

        this.state = {
            rssFeedLimit: 50,
            rssFeedStart: 0,
            isLoading: true,
            selectedState:'',
            availableDistrict:[]
        }
    }

    checkUserStoredState = () => {
        let userStateAvailabe = Boolean(JSON.parse(sessionStorage.getItem('custom')).json_value.active_location) ? JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.state : false;
        return userStateAvailabe;
    }


    componentWillMount() {
            setTimeout(() => {
            if(this.checkUserStoredState()){
            let userStateAvailabe = JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.state;
            let userDistrictAvailabe = JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.district;
                this.props.getCovidGlobalDashboard(userStateAvailabe, userDistrictAvailabe)
            }
            else {
                this.props.getCovidGlobalDashboard(null,null)
    
            }
        }, 100);
        this.props.getCovidGlobalSymptoms()
        this.props.getCovidGoogleRSSFeed(this.state.rssFeedLimit, this.state.rssFeedStart)

        // const googleNews = new GoogleNewsRss()
        // googleNews.search('q=covid-19&hl=en-US&sort=date&gl=IN').then(resp=>{
        //     console.log(resp)
        // });
    }

    componentWillReceiveProps(newProps) {
        if (this.props.organization.stateName !== newProps.organization.stateName || this.props.organization.cityName !== newProps.organization.cityName) {
            // this.props.getCovidGlobalDashboard(newProps.organization.stateName, newProps.organization.cityName)
            this.props.getCovidGlobalSymptoms()
        }

        if (this.props.covidGoogleRSSFeed !== newProps.covidGoogleRSSFeed) {
            this.setState({ isLoading: false })
        }
    }

    componentDidUpdate(oldProps, oldState) {}

    checkUserAddressAvailable = () => {
        var stateValidation = JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.state;
        var districtValidation = JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.district;

    }

    getUserStateName = () => {
        let state = "India";
        if(this.checkUserStoredState()) {
            var stateValidation = JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.state;
            if(Boolean(stateValidation)){
                state = Constants.titleCase(stateValidation);
            }
        }
        return state;
    }

    getUserDistrictName = () => {
        let district = '';
        if(this.checkUserStoredState()){
            var districtValidation = JSON.parse(sessionStorage.getItem('custom')).json_value.active_location.district;
            if(Boolean(districtValidation)){
                district = Constants.titleCase(districtValidation);
            }
        }
        return district !== '' ? ' - ' + district : '';
    }

    covidDeclarationGlobalStats = () => (
        <div>
            <div className="col-xs-12 padding-0" style={{ paddingLeft: 15, marginBottom: 4 }}>
                <div className="col-xs-12 padding-0 hsg-covid-stats-covid-declaration-global-stats-head">
                    <div style={{ paddingLeft: 16,  minWidth: 240 }}>
                        <div className="hsg-dashboard-card hsg-covid-stats-covid-declaration-global-stats-content" style={{ width: "100%" }}>
                            <div className="" style={{ marginTop: 10 }}>
                                {Source.STRING_LIVE_UPDATES}
                            </div>
                        </div>
                    </div>
                    <div style={{ paddingLeft: 16,  }}>
                        <div className="hsg-dashboard-card hsg-covid-stats-covid-declaration-global-stats-content">
                            <div className="hsg-dashboard-covid-declaration-global-stats-sub-content">
                                {/* <span>
                                    {this.props.organization.stateName && this.props.organization.cityName
                                        ? `${this.props.organization.stateName} - ${this.props.organization.cityName}`
                                        : "India"}
                                </span> */}
                                <span>
                                    {this.getUserStateName()}
                                    {this.getUserDistrictName()}
                                    {/* {Boolean(sessionStorage.getItem('selected-state')) ? sessionStorage.getItem('selected-state').split('&&')[0].charAt(0).toUpperCase() + sessionStorage.getItem('selected-state').split('&&')[0].slice(1) : 'India'}  */}
                                    {/* {Boolean(sessionStorage.getItem('selected-city')) && ' - ' + sessionStorage.getItem('selected-city').split('&&')[0]}  */}
                                </span>
                                <img
                                    style={{ paddingLeft: 16, cursor: "pointer" }}
                                    src={iconLocation}
                                    onClick={() => this.props.toggleUserProfileModal(true,'covid')}
                                    aria-hidden="true"
                                ></img>
                            </div>

                            <a
                                href={Source.URL_COVID_DASHBOARD_REF}
                                target="_blank"
                                className="col-xs-6 padding-0 left hsg-dashboard-covid-declaration-global-stats-option"
                            >
                                {Source.STRING_GLOBAL_STATS_VIEW_MORE}
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-xs-12 padding-0 hsg-scroll-horizontal-scroll hsg-dashboard-covid-overall-numbers-group">
                {Source.COVID_DECLARATION_GLOBAL_STATS.map((element, index) => (
                    <div className={element.className} key={index}>
                        <div className="hsg-dashboard-covid-overall-numbers hsg-dashboard-card">
                            <div className="col-xs-8 left padding-0">
                                <div className="hsg-dashboard-covid-overall-numbers-label">{element.label}</div>
                                <div className="hsg-dashboard-covid-overall-numbers-value">
                                    {this.props.covidGlobalDashboard[element.key] ? Number(this.props.covidGlobalDashboard[element.key]).toLocaleString() : 0}
                                </div>
                            </div>
                            <div className="col-xs-4 center padding-0 hsg-dashboard-covid-overall-numbers-icon-group">
                                <div className="hsg-dashboard-covid-overall-numbers-icon-frame center" style={element.iconBackground}>
                                    <img className="hsg-dashboard-covid-overall-numbers-icon" aria-hidden="true" src={element.icon} />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )

    covidDeclarationSymptomAnalysis = () => (
        <div className="container-fluid hsg-dashboard-card hsg-dashboard-covid-declaration-analysis-container">
            <div className="col-xs-12 padding-0">
                <div className="col-xs-12 col-sm-12 padding-0 hsg-dashboard-covid-declaration-analysis-heading">{Source.STRING_SYMPTOMS_HEADING}</div>
                <div className="col-xs-12 col-sm-12 padding-0 hsg-dashboard-covid-declaration-analysis-sub-heading">{Source.STRING_SYMPTOMS_SUB_HEADING}</div>
            </div>
            <div className="col-xs-12 padding-0 margin-top-30 container-fluid hsg-covid-declaration-analysis-graph-group ">
                {Source.COVID_DECLARATION_SYMPTOMS.map((element, index) => (
                    <div className={element.className} key={index}>
                        <div className="hsg-covid-stats-covid-overall-numbers" style={{ display: "flex" }} style={{ flex: 2 }}>
                            <div className="padding-0 hsg-covid-stats-covid-overall-numbers-icon-group">
                                <div
                                    className="hsg-covid-stats-covid-overall-numbers-icon-frame center"
                                    // style={element.iconBackground}
                                >
                                    <img className="hsg-covid-stats-covid-overall-numbers-icon" aria-hidden="true" src={element.icon} />
                                </div>
                            </div>
                            <div className="padding-0" style={{ flex: 6 }}>
                                <div className="hsg-covid-stats-covid-overall-numbers-label">{element.label}</div>
                            </div>
                            <div className="padding-0" style={{ flex: 2 }}>
                                <div className="hsg-covid-stats-covid-overall-numbers-value">
                                    {`${this.props.covidDeclarationSymptoms[element.key] || "0"}%`}
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )

    handleScroll = (e) => {
        // let element = e.target
        // if (element.scrollHeight - element.scrollTop <= element.clientHeight + 50) {
        //     if (this.state.rssFeedLimit + this.state.rssFeedStart < 1000 && this.state.isLoading === false) {
        //         this.props.getCovidGoogleRSSFeed(this.state.rssFeedLimit + 100, this.state.rssFeedStart + 100)
        //         this.setState({ rssFeedLimit: this.state.rssFeedLimit + 100, rssFeedStart: this.state.rssFeedStart + 100, isLoading: true })
        //     }
        // }
    }

    covidDeclarationRSSFeed = () => {
        // function htmlEscape(str) {
        //     return String(str)
        //             .replace(/&amp;/g, '&')
        //             .replace(/&quot;/g, '"')
        //             .replace(/&#39;/g, "'")
        //             .replace(/&lt;/g, '<')
        //             .replace(/&gt;/g, '>');
        // }

        return (
            <div className="container-fluid hsg-dashboard-card hsg-covid-stats-rss-feed-item-container">
                <div className="col-xs-12 padding-0 container-fluid hsg-covid-stats-rss-feed-item-group" onScroll={this.handleScroll}>
                    {!this.state.isLoading || this.props.covidGoogleRSSFeed.length ? (
                        this.props.covidGoogleRSSFeed.map((element, index) => {
                            let possibleData = element.title.split(" - ")
                            let title = possibleData[0]
                            let source = possibleData[1]
                            return (
                                <div key={index} className="hsg-covid-stats-rss-feed-item">
                                    <a href={element.link} style={{ color: "#333333" }} target="_blank">
                                        <div className="hsg-covid-stats-rss-feed-item-content">
                                            <div className="hsg-covid-stats-rss-feed-item-content-head">{title}</div>
                                            <div className="hsg-covid-stats-rss-feed-item-content-extra">
                                                <span className="padding">{element.source}</span>
                                                <span className="padding">
                                                    <i className="fa fa-clock-o" aria-hidden="true"></i>
                                                </span>
                                                <span className="padding">
                                                    {moment(moment(element.pubDate).format("MMMM Do YYYY, h:mm:ss a"), "MMMM Do YYYY, h:mm:ss a").fromNow()}
                                                </span>
                                                {/* <span style={{ display: "inline-block" }}>
                                                    {" "}
                                                    <span className="padding bullet">
                                                        {moment(moment(element.pubDate).format("MMMM Do YYYY, h:mm:ss a"), "MMMM Do YYYY, h:mm:ss a").fromNow()}
                                                    </span>
                                                </span> */}
                                            </div>
                                        </div>
                                    </a>

                                    {/* {this.props.covidGoogleRSSFeedImages[index] ? (
                                        <div className="hsg-covid-stats-rss-feed-item-image">
                                            <LazyLoadImage
                                                effect="blur"
                                                delayTime={1000}
                                                src={this.props.covidGoogleRSSFeedImages[index]}
                                                height={100}
                                                width={100}
                                            />
                                        </div>
                                    ) : (
                                        <div className="hsg-covid-stats-rss-feed-item-image-icon">
                                            <i className="fa fa-rss" aria-hidden="true"></i>
                                        </div>
                                    )} */}
                                </div>
                            )
                        })
                    ) : (
                        <Loader blockUI={false} isLoading={this.state.isLoading} />
                    )}
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className="container-fluid padding-left-0 margin-top-30 margin-bottom-20">
                <div className="col-xs-12 padding-left-0">{this.covidDeclarationGlobalStats()}</div>

                <div className="col-xs-12 padding-0 margin-top-20">
                    <div className="col-xs-12 col-sm-5 padding-right-0" style={{ display: "table-cell" }}>
                        {this.covidDeclarationSymptomAnalysis()}
                    </div>
                    <div className="col-xs-12 col-sm-7 customRssFeed" style={{ display: "table-cell" }}>
                        {this.covidDeclarationRSSFeed()}
                    </div>
                </div>
            </div>
        )
    }
}

export default CovidStats
    